<template>
  <v-card flat class="px-3">
    <v-col cols="12" class="body-bold-smaller py-0">
      <a type="primary" size="xsmall" @click="beforeLeave">
        <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
        {{ $t('message.actions.return') }}
      </a>
    </v-col>

    <v-col class="pt-1 py-0">
      <span class="body-bold-medium">{{
        $t('message.pages.video.chapters')
      }}</span>
    </v-col>

    <v-col cols="12" class="py-0">
      <span class="body-regular-smaller textType6--text pageDescription">
        {{ $t('message.pages.video.messageChapters') }}
        <a target="_blank" type="secondary" :href="chapterArticle">
          <span>
            {{ $t('message.embedModal.knowMore') }}
          </span>
          <v-icon size="12">mdi-open-in-new</v-icon>
        </a>
      </span>
    </v-col>

    <v-col cols="12" class="pt-6 pb-0">
      <span class="body-bold-base" ref="topElement">
        {{ $t('message.pages.videoPlayerChapters.chooseTime') }}
      </span>
    </v-col>

    <v-card style="overflow: auto" flat>
      <v-card v-if="arrayChapters.length > 0" flat class="ml-2">
        <v-row no-gutters>
          <v-col cols="12" v-for="(chapter, i) in arrayChapters" :key="i">
            <v-card class="mt-2" flat>
              <v-row class="pt-1" no-gutters justify="center" align="center">
                <v-input
                  :value="chapter.timeFormated"
                  hide-details
                  outlined
                  color="primary"
                  :error="chapter.error"
                  :maxlength="timeVideo >= 3600 ? 8 : 5"
                  :style="
                    timeVideo >= 3600 ? 'max-width: 80px' : 'max-width: 55px'
                  "
                  ref="timeChapter"
                  class="mr-2"
                  :disabled="loadingButtonSave || !hasEditVideoPerm"
                  @keydown="(e) => onKeyDownInput(e, chapter, i)"
                  @blur="editChapter(i)"
                >
                </v-input>
                <v-input
                  v-model="chapter.title"
                  :placeholder="
                    $t('message.pages.videoPlayerChapters.chaptersTitle')
                  "
                  hide-details
                  outlined
                  color="primary"
                  :maxlength="35"
                  :error="chapter.error"
                  ref="titleChapter"
                  @blur="editChapter(i)"
                  @focus="inputBeingEdited(i, 'titleChapter')"
                  :class="{ inputActive: i + 'titleChapter' === activeInput }"
                  :disabled="loadingButtonSave || !hasEditVideoPerm"
                >
                </v-input>

                {{ error }}

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn
                        plain
                        icon
                        :error="checkValidateInputsChapter()"
                        @click="removeChapter(i)"
                        :disabled="loadingButtonSave || !hasEditVideoPerm"
                        class="d-table removeChapter ml-2"
                        style="margin: 0 auto"
                      >
                        <v-icon size="20"> panda-remove </v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span>{{ $t('message.remove') }}</span>
                </v-tooltip>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <span
        v-if="checkValidateInputsChapter()"
        class="errorMessage body-regular-small align-text ml-2 mt-2 d-block"
      >
        {{ errorMessage }}
      </span>

      <span
        v-if="internalError"
        class="red--text caption align-text ml-2 mt-2 d-block"
      >
        <v-icon color="red" size="16" class="mt-n1"> mdi-alert-circle </v-icon>
        {{ $t('message.pages.video.errors.addChapter') }}
      </span>

      <base-btn
        class="px-3 ml-2 mt-4"
        type="secondary"
        size="small"
        @click="addChapter(), checkValidateInputsChapter()"
        :disabled="checkValidateInputsChapter() || loadingButtonSave"
        v-if="hasEditVideoPerm"
      >
        <v-icon size="20"> mdi-plus </v-icon>
        {{ $t('message.pages.videoPlayerChapters.addChapter') }}
      </base-btn>
    </v-card>

    <portal to="actions-footer">
      <ActionModal
        v-if="hasEditVideoPerm"
        :showAction1="hasEditVideoPerm"
        :showAction2="hasEditVideoPerm"
        :disableTooltip1="!withoutChanges"
        :disableTooltip2="!withoutChanges"
        :disabledAction1="loadingButtonSave || withoutChanges"
        :disabledAction2="
          loadingButtonSave ||
          checkValidateInputsChapter() ||
          withoutChanges      
        "
        :handleAction1="handleUndoChanges"
        :handleAction2="handleUpdateChapters"
        :loadingAction2="loadingButtonSave"
      />
    </portal>

    <unsaved-changes-modal />
  </v-card>
</template>

<script>
import UnsavedChangesModal from '../../../components/UnsavedChangesModal.vue'
import ActionModal from '@/components/ActionModal.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import _ from 'lodash'
import i18n from '@/translations/lang'

export default {
  name: 'VideoPlayerChapters',
  components: {
    UnsavedChangesModal,
    ActionModal,
  },
  directives: { mask },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    videoId: '',
    loadingButtonSave: false,
    initialConfig: {
      arrayChapters: [],
    },
    timeVideo: 0,
    repeatedTimeChapter: 0,
    videoCurrentTime: 0,
    cardHeight: 0,
    errorMessage: '',
    error: '',
    arrayChapters: [],
    newChapter: {
      title: '',
      time: 0,
      timeFormated: '00:00',
    },
    activeInput: null,
    withoutChanges: true,
  }),
  mounted() {
    this.$root.$on('changeLanguage', this.updateInput)
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.arrayChapters = this.$store.state.video.video.config?.bookMarks
    this.timeVideo = this.$store.state.video.video?.length
    this.newChapter.title = this.$t('message.pages.video.chaptersTitle')
    if (!this.arrayChapters) {
      this.arrayChapters = []
      this.initialConfig.arrayChapters = []
    }
    for (const object of this.arrayChapters) {
      if (object.time) {
        object['timeFormated'] = this.formatTime(object.time)
      }
    }
    this.initialConfig.arrayChapters = _.cloneDeep(this.arrayChapters)
    this.hasEdit.push(this.checkChanges)
    this.changePlayer()
    window.addEventListener(
      'message',
      (event) => {
        const { data } = event
        if (data.message === 'panda_timeupdate') {
          this.videoCurrentTime = Math.round(data.currentTime)
        }
      },
      '*'
    )
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
    })
  },
  beforeDestroy() {
    this.arrayChapters = _.cloneDeep(this.initialConfig.arrayChapters)
    this.changePlayer()
  },
  watch: {
    '$store.state.video.video': {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
    arrayChapters: {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
    locale() {
      return this.$i18next.resolvedLanguage
    },
    chapterArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/chapters-separate-the-video-content-into-topics-1v3ev3n/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/capitulos-separa-el-contenido-del-video-en-temas-fcn93z/'
      }
      return 'https://help.pandavideo.com/pt-br/article/capitulos-separe-o-conteudo-do-video-em-topicos-mnpqzj/'
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
  },
  methods: {
    ...mapActions('video', [
      'updateChapter',
      'createProfile',
      'setProfileToVideos',
    ]),
    updateInput() {
      const defaultTranslations = [
        'Título do Capítulo',
        "Chapter's title", // eslint-disable-line quotes
        'Título del capítulo',
      ]
      const currentTranslation = this.$t('message.pages.video.chaptersTitle')
      this.arrayChapters.forEach((chapter) => {
        if (Object.values(defaultTranslations).includes(chapter.title)) {
          chapter.title = currentTranslation
        }
      })

      this.arrayChapters = [...this.arrayChapters]
    },
    ...mapMutations('video', ['UPDATE_VIDEO', 'UPDATE_STATUS_ERROR']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async handleUpdateChapters() {
      this.loadingButtonSave = true
      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
      this.arrayChapters.forEach((object) => {
        delete object['timeFormated']
      })
      try {
        await this.updateChapter([this.videoId, this.arrayChapters])
        for (const object of this.arrayChapters) {
          if (object.time || object.time === 0) {
            object['timeFormated'] = this.formatTime(object.time)
          }
        }
        this.loadingButtonSave = false
        this.internalError
          ? ''
          : ((this.initialConfig.arrayChapters = _.cloneDeep(
              this.arrayChapters
            )),
            this.handleSnackbar(this.$t('message.pages.video.changesSaved')),
            (this.withoutChanges = true))
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    changePlayer() {
      const pandaPlayer = document.getElementById('panda-player')
      if (pandaPlayer) {
        const iframe = pandaPlayer.contentWindow
        iframe.postMessage(
          {
            type: 'bookMarks',
            parameter: {
              bookMarks: this.arrayChapters,
            },
          },
          '*'
        )
        if (!this.video.config) this.video.config = {}
        this.video.config.bookMarks = this.arrayChapters
        this.UPDATE_VIDEO(this.video)
        this.UPDATE_STATUS_ERROR(false)
      } else if (this.video) {
        if (!this.video.config) this.video.config = {}
        this.video.config.bookMarks = this.arrayChapters
        this.UPDATE_VIDEO(this.video)
        this.UPDATE_STATUS_ERROR(false)
        this.$root.$emit('setBookmarks', this.arrayChapters)
      }
    },
    handleUndoChanges() {
      this.arrayChapters = _.cloneDeep(this.initialConfig.arrayChapters)
      this.changePlayer()
    },
    checkChanges() {
      return _.isEqual(
        this.video.config.bookMarks,
        this.initialConfig.arrayChapters
      )
    },
    beforeLeave() {
      if (!this.checkChanges()) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.UPDATE_STATUS_ERROR(false)
        this.handleBack()
      }
    },
    addChapter() {
      const resetTime = '00:00'
      this.videoCurrentTimed = resetTime

      this.arrayChapters.push({
        time: this.videoCurrentTime,
        title: this.$t('message.pages.video.chaptersTitle'),
        timeFormated: this.formatTime(this.videoCurrentTime),
      })

      this.changePlayer()
    },
    restrictInput(event) {
      const allowedKeys = [
        'Backspace',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        'Tab',
      ]
      if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
        event.preventDefault()
      }
    },
    removeChapter(index) {
      this.arrayChapters.splice(index, 1)
      this.changePlayer()
      this.removeChapterSnackbar()
    },
    applyMask(chapter) {
      let input = chapter.timeFormated.replace(/[^0-9]/g, '')
      const maxLength = this.timeVideo >= 3600 ? 6 : 4

      if (input.length > maxLength) {
        input = input.slice(0, maxLength)
      }

      if (this.timeVideo >= 3600) {
        chapter.timeFormated = input
          .replace(/^(\d{2})(\d{2})(\d{2})$/, '$1:$2:$3')
          .replace(/^(\d{2})(\d{2})$/, '00:$1:$2')
          .replace(/^(\d{2})$/, '00:00:$1')
      } else {
        chapter.timeFormated = input
          .replace(/^(\d{2})(\d{2})$/, '$1:$2')
          .replace(/^(\d{2})$/, '00:$1')
      }
    },
    editChapter(index) {
      const input = this.arrayChapters[index].timeFormated.replace(
        /[^0-9]/g,
        ''
      )
      const maxLength = this.timeVideo >= 3600 ? 6 : 4
      const trimmedInput = input.slice(0, maxLength)

      let formatted
      if (this.timeVideo >= 3600) {
        formatted = trimmedInput
          .padStart(6, '0')
          .replace(/^(\d{2})(\d{2})(\d{2})$/, '$1:$2:$3')
      } else {
        formatted = trimmedInput
          .padStart(4, '0')
          .replace(/^(\d{2})(\d{2})$/, '$1:$2')
      }

      const timeParts = formatted.split(':').map(Number)

      let seconds
      if (this.timeVideo >= 3600) {
        const hours = timeParts[0] || 0
        const minutes = timeParts[1] || 0
        const secs = timeParts[2] || 0

        const validMinutes = Math.floor(minutes % 60)
        const validSeconds = Math.floor(secs % 60)
        const carryHours = Math.floor(minutes / 60)

        const finalHours = hours + carryHours
        formatted = `${finalHours.toString().padStart(2, '0')}:${validMinutes
          .toString()
          .padStart(2, '0')}:${validSeconds.toString().padStart(2, '0')}`
        seconds = finalHours * 3600 + validMinutes * 60 + validSeconds
      } else {
        const minutes = timeParts[0] || 0
        const secs = timeParts[1] || 0

        const validSeconds = Math.floor(secs % 60)
        const carryMinutes = Math.floor(secs / 60)

        const finalMinutes = minutes + carryMinutes
        formatted = `${finalMinutes.toString().padStart(2, '0')}:${validSeconds
          .toString()
          .padStart(2, '0')}`
        seconds = finalMinutes * 60 + validSeconds
      }

      if (seconds > this.timeVideo) {
        seconds = this.timeVideo - 1
        formatted = this.formatTime(seconds)
      }

      this.arrayChapters[index].timeFormated = formatted
      this.arrayChapters[index].time = seconds

      this.arrayChapters.sort((a, b) => a.time - b.time)
      this.changePlayer()
    },
    onKeyDownInput(event, chapter) {
      const allowedKeys = [
        'Backspace',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Delete',
      ]

      if (allowedKeys.includes(event.key)) {
        return
      }

      if (!/^\d$/.test(event.key)) {
        event.preventDefault()
        return
      }

      let numbers = event.target.value.replace(/\D/g, '')
      if (event.key === 'Backspace') {
        numbers = numbers.slice(0, -1)
      } else {
        numbers += event.key
      }

      if (this.timeVideo >= 3600) {
        numbers = numbers.padStart(6, '0').slice(-6)

        const hours = numbers.slice(0, 2)
        const minutes = numbers.slice(2, 4)
        const seconds = numbers.slice(4, 6)

        chapter.timeFormated = `${hours}:${minutes}:${seconds}`
      } else {
        numbers = numbers.padStart(4, '0').slice(-4)

        const minutes = numbers.slice(0, 2)
        const seconds = numbers.slice(2, 4)

        chapter.timeFormated = `${minutes}:${seconds}`
      }

      event.preventDefault()
    },
    checkValidateInputsChapter() {
      const timeSet = new Set()
      let hasError = false
      let errorMessages = []

      this.arrayChapters.forEach((chapter, index) => {
        chapter.error = false
        if (!chapter.title || chapter.title.length < 3) {
          chapter.error = true
          errorMessages.push(
            this.$t('message.pages.videoPlayerChapters.errors.titleSize', {
              index: index + 1,
            })
          )
          hasError = true
        }
        if (timeSet.has(chapter.time)) {
          chapter.error = true
          errorMessages.push(
            this.$t(
              'message.pages.videoPlayerChapters.errors.duplicatedChapter',
              {
                chapter: this.formatTime(chapter.time),
              }
            )
          )
          hasError = true
        } else {
          timeSet.add(chapter.time)
        }
      })

      this.errorMessage = errorMessages.join(' ')
      return hasError
    },
    inputBeingEdited(i, ref) {
      this.activeInput = i
      if (ref) {
        this.activeInput = i + ref
      }
    },
    formatTime(seconds) {
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = Math.round(seconds % 60)
      if (this.seconds === 0) {
        return '00:00'
      }
      if (this.timeVideo >= 3600) {
        return [
          h > 9 ? h : h ? '0' + h : '0' + h || '00',
          m > 9 ? m : h ? '0' + m : '0' + m || '00',
          s > 9 ? s : '0' + s,
        ]
          .filter(Boolean)
          .join(':')
      } else {
        return [m > 9 ? m : h ? '0' + m : '0' + m || '00', s > 9 ? s : '0' + s]
          .filter(Boolean)
          .join(':')
      }
    },
    removeChapterSnackbar() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.pages.videoPlayerChapters.removeSuccess'),
        type: 'success',
      })
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.backIcon {
  color: varFigma(brand-60-base) !important;
}

.backBtn {
  cursor: pointer;
}

.errorMessage {
  color: varFigma(feedback-danger-dark) !important;
}

.removeChapter {
  color: varFigma(feedback-danger) !important;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: varFigma(feedback-danger-background);
}

.v-card > *:last-child:not(.v-btn):not(.v-chip):not(.v-avatar) {
  border-radius: 8px;
}

::v-deep
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding: 0 8px !important;
}

.pageDescription {
  color: varFigma(neutral-40-light);
}
</style>
